import { useEffect, useRef, useState } from "react";
import { getApiService } from "../services/api";
import { isValidPhone } from "../services/format";

// 短信验证码发送与倒计时
export function useCaptcha() {
  const [countdown, setCountdown] = useState(0);
  const [sending, setSending] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const send = async (phone: string): Promise<{ ok: boolean; message?: string }> => {
    if (!isValidPhone(phone)) {
      return { ok: false, message: "手机号格式错误" };
    }
    if (countdown > 0) return { ok: true };
    setSending(true);
    try {
      const res = await getApiService().sendCaptcha(phone);
      if (res.code !== 200) {
        return { ok: false, message: res.message ?? "发送失败" };
      }
      setCountdown(60);
      timerRef.current = setInterval(() => {
        setCountdown((c) => {
          if (c <= 1 && timerRef.current) clearInterval(timerRef.current);
          return c - 1;
        });
      }, 1000);
      return { ok: true };
    } finally {
      setSending(false);
    }
  };

  return { countdown, sending, send };
}
